import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Redo = createReactComponent("Redo", ["svg", defaultAttributes, [["polyline", {
  points: "22 10 22 16 16 16",
  key: "rjn2t"
}], ["path", {
  d: "M1.994 16c1.813-6.542 9.559-9.482 15.36-4.36l4.64 4.36",
  key: "11ok0f"
}]]]);
export default Redo;